import { render } from "./TheMain.vue?vue&type=template&id=779ee4d3&scoped=true"
import script from "./TheMain.vue?vue&type=script&lang=js"
export * from "./TheMain.vue?vue&type=script&lang=js"

import "./TheMain.vue?vue&type=style&index=0&id=779ee4d3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-779ee4d3"

export default script